import { createSelector } from 'reselect';

const rootCausesStore = (store) => store.apps.builds.rootCauses;
const userStore = (store) => store.user;
const buildStore = (store) => store.apps.builds.container;

export const buildUserSelector = createSelector([
  buildStore,
  userStore,
],
(builds) => ({
  build_name: builds.getIn(['build', 'name']),
  username: builds.getIn(['build', 'org_id']),
  ownerType: 'org',
}));

export const buildRootCausesSelector = createSelector(
  rootCausesStore,
  (rootCauses) => ({
    loadingData: rootCauses.get('loadingData'),
    items: rootCauses.get('items'),
  }),
);

export const rootCauseDataSelector = createSelector([
  rootCausesStore,
  (store, options) => options,
], (rootCauses, options) => rootCauses.getIn(['items', options.patternId]));

export const rootCauseAdditionalDataSelector = createSelector([
  rootCausesStore,
  (store, options) => options,
], (rootCauses, options) => {
  const rootCauseItem = rootCauses.getIn(['items', options.patternId]);
  const annotations = rootCauseItem.getIn(['annotations', 'data']);
  const jobs = rootCauseItem.getIn(['jobs', 'data']);
  return {
    isDataExists: !!(annotations?.length && jobs?.length),
  };
});
